import React, {useState} from 'react'

import {isElement} from 'react-is'

import ModalPortal from '../modal-portal'

export interface Props {
  children: (args: {isOpen: boolean; open: () => void; close: () => void}) => React.ReactNode
  modal:
    | React.ReactElement
    | ((args: {isOpen: boolean; open: () => void; close: () => void}) => React.ReactElement)
  closable?: boolean
  lightbox?: boolean
}

const ModalHandler = ({children, modal, closable = true, lightbox = false}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  return (
    <>
      {children({isOpen, open, close})}
      <ModalPortal isOpen={isOpen} onClose={closable ? close : undefined} lightbox={lightbox}>
        {React.cloneElement(isElement(modal) ? modal : modal({isOpen, open, close}), {
          onClose: closable ? close : undefined,
        })}
      </ModalPortal>
    </>
  )
}

export default ModalHandler
